import { render, staticRenderFns } from "./HistoryRecordData.vue?vue&type=template&id=5f9daf94&scoped=true&"
import script from "./HistoryRecordData.vue?vue&type=script&lang=js&"
export * from "./HistoryRecordData.vue?vue&type=script&lang=js&"
import style0 from "./HistoryRecordData.vue?vue&type=style&index=0&id=5f9daf94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9daf94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f9daf94')) {
      api.createRecord('5f9daf94', component.options)
    } else {
      api.reload('5f9daf94', component.options)
    }
    module.hot.accept("./HistoryRecordData.vue?vue&type=template&id=5f9daf94&scoped=true&", function () {
      api.rerender('5f9daf94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/RecordHistory/HistoryRecordData.vue"
export default component.exports